import { Component, OnInit } from '@angular/core';
import { LocalStorage } from '@ngx-pwa/local-storage';
import { IMediosImpactoAmbiental } from 'src/app/interface/interfaces';
import { SenaceService } from 'src/app/services/senace.service';

@Component({
  selector: 'app-impacto-ambiental',
  templateUrl: './impacto-ambiental.component.html',
  styleUrls: ['./impacto-ambiental.component.css']
})
export class ImpactoAmbientalComponent implements OnInit {

  componenteImpactoAmbiental = {
    titulo: 'CARACTERIZACION DE IMPACTOS AMBIENTALES',
    cabecera: ['Etapa', 'Tipo', 'Medio', 'Efecto', 'Descripción'],
    filas: []
  };

  constructor(
    private localStorage: LocalStorage,
    private senaceService: SenaceService
  ) { }

  ngOnInit() {
    this.localStorage.getItem('detalle').subscribe(
      resp => {
        const datos = this.senaceService.getImpactoAmbiental(resp);
        this.getImpactoAmbiental(datos);
      }
    );
  }

  getImpactoAmbiental(resultado) {
    let datos:IMediosImpactoAmbiental[] = [];
    let data: any[] = resultado;
    if (data) {
      data.forEach(item => {
        if(item.medios){
          item.medios.forEach( impactoAmbiental =>{
              datos.push(impactoAmbiental);
          });          
        }
      });
    }
    datos.forEach(item => {
      let arr = [item.etapa || '', item.tipo || '', item.medio || '', item.efecto || '', item.descripcion || ''];
      this.componenteImpactoAmbiental.filas.push(...[arr]);
    });
  }

}
